import { render } from "./booking-instant-v2.vue?vue&type=template&id=ed9ac292&ts=true"
import script from "./booking-instant-v2.vue?vue&type=script&lang=ts"
export * from "./booking-instant-v2.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__